export default [
  {
    stage: "I этап.",
    title: "Подписание проекта документа",
    queueType: "последовательное", // тип очереди (параллельное или последовательное)
    state: "очередь не запущена", // Состояние этапа
    tasks: [
      {
        status: "задача в ожидании", // Состояние задачи (задача в ожидании, задача в работе, задача согласована (завершена), задача отклонена (завершена))
        progress: "", // прогресс бар
        expired: false, // задача просрочена или не просрочена
        statusMessage: "Осталось 2 дня",
        startDate: "17.03.2021",
        startTime: "12:54",
        resolutionDate: "18.03.2021",
        resolutionTime: "12:56",
        author: {
          name: "Горин Игорь Андреевич",
          initials: "ГИ",
          photo: "8"
        },
        executor: {
          name: "Иванов Иван Иванович",
          initials: "ИИ",
          photo: "7"
        },
        description: "«Согласование постановления Правительства РФ от 13.08.2020 N 1009 (ред. от 31.12.2 020) «Об утверждении Правил подготовки нормативных правовых актов федеральных органов исполнительной власти и их государственной регистрации»",
        executionPeriod: {
          startDate: "16.03.2021",
          startTime: "02:45",
          endDate: "18.04.2021",
          endTime: "23:00",
        },
        comments: [
          {
            user: {
              photo: "",
              name: "Петренко Анна Николаевна",
              initials: "ПА"
            },
            date: "17.03.2021",
            time: "12:54",
            quote: "Документация не соответствует требованиям технического отдела"
          },
          {
            user: {
              photo: "8",
              name: "Александр Филонов",
              initials: "АФ"
            },
            date: "18.03.2021",
            time: "17:02",
            quote: "Так же прошу обратить внимание на раздел договора 2.1 п.3.67"
          }
        ]
      }
    ]
  },
  {
    stage: "II этап.",
    title: "Согласование проекта документа",
    queueType: "параллельное",
    state: "очередь находится на согласовании",
    status: "не согласовано",
    expired: true,
    tasks: [
      {
        status: "задача в работе",
        delegation: true,
        progress: "до срока исполнения (Period.End) осталось > 30% времени",
        expired: false,
        statusMessage: "Осталось 2 дня",
        startDate: "17.03.2021",
        startTime: "12:54",
        resolutionDate: "18.03.2021",
        resolutionTime: "12:56",
        author: {
          name: "Горин Игорь Андреевич",
          initials: "ГИ",
          photo: "8"
        },
        executor: {
          name: "Иванов Иван Иванович",
          initials: "ИИ",
          photo: "7"
        },
        description: "«Согласование постановления Правительства РФ от 13.08.2020 N 1009 (ред. от 31.12.2 020) «Об утверждении Правил подготовки нормативных правовых актов федеральных органов исполнительной власти и их государственной регистрации»",
        executionPeriod: {
          startDate: "17.03.2021",
          startTime: "09:45",
          endDate: "18.03.2021",
          endTime: "18:00",
        },
        comments: [
          {
            user: {
              avatar: "2",
              name: "Петренко Анна Николаевна"
            },
            date: "17.03.2021",
            time: "12:54",
            quote: "Документация не соответствует требованиям технического отдела"
          }
        ]
      },
      {
        status: "завершено с положительным результатом (т.е. согласовано)",
        delegation: false,
        progress: "до срока исполнения (Period.End) осталось < 10% времени",
        expired: false,
        statusMessage: "Осталось 2 дня",
        startDate: "17.03.2021",
        startTime: "12:54",
        resolutionDate: "18.03.2021",
        resolutionTime: "12:56",
        author: {
          name: "Горин Игорь Андреевич",
          initials: "ГИ",
          photo: "8"
        },
        executor: {
          name: "Иванов Иван Иванович",
          initials: "ИИ",
          photo: "7"
        },
        description: "«Согласование постановления Правительства РФ от 13.08.2020 N 1009 (ред. от 31.12.2 020) «Об утверждении Правил подготовки нормативных правовых актов федеральных органов исполнительной власти и их государственной регистрации»",
        executionPeriod: {
          startDate: "17.03.2021",
          startTime: "09:45",
          endDate: "18.03.2021",
          endTime: "18:00",
        },
        comments: [
          {
            user: {
              avatar: "2",
              name: "Петренко Анна Николаевна"
            },
            date: "17.03.2021",
            time: "12:54",
            quote: "Документация не соответствует требованиям технического отдела"
          }
        ]
      },
      {
        status: "задача в работе",
        delegation: false,
        progress: "до срока исполнения (Period.End) осталось от 10 до 30% времени",
        expired: false,
        statusMessage: "Осталось 2 дня",
        startDate: "17.03.2021",
        startTime: "12:54",
        resolutionDate: "18.03.2021",
        resolutionTime: "12:56",
        author: {
          name: "Горин Игорь Андреевич",
          initials: "ГИ",
          photo: "8"
        },
        executor: {
          name: "Иванов Иван Иванович",
          initials: "ИИ",
          photo: "7"
        },
        description: "«Согласование постановления Правительства РФ от 13.08.2020 N 1009 (ред. от 31.12.2 020) «Об утверждении Правил подготовки нормативных правовых актов федеральных органов исполнительной власти и их государственной регистрации»",
        executionPeriod: {
          startDate: "17.03.2021",
          startTime: "09:45",
          endDate: "18.03.2021",
          endTime: "18:00",
        },
        comments: [
          {
            user: {
              avatar: "2",
              name: "Петренко Анна Николаевна"
            },
            date: "17.03.2021",
            time: "12:54",
            quote: "Документация не соответствует требованиям технического отдела"
          }
        ]
      }
    ]
  }
]
